module.exports = __webpack_public_path__ + "h5/img/pro3.048c1df8.png";